import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Helper } from '../../Helper';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-view-message',
  templateUrl: './view-message.component.html',
  styleUrls: ['./view-message.component.css','../../sub-admin/subadmin.component.css','../../../assets/bootstrap.css']


  
})
export class ViewMessageComponent implements OnInit {
  data=[];
  form;
  messageId="";

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
};
  constructor(public Helper:Helper,private route:ActivatedRoute ) { 
    this.editorConfig["uploadUrl"]=this.Helper.globalAPiUrl+"admin/upload-image?token="+this.Helper.get("token");
  }
  @Output() onBack=new EventEmitter;
  @Input()
  set setMessageId(val: any) {
   
    this.messageId=val;
    this.init();
     
  }
  ngOnInit() {
    this.form = new FormGroup({
        
      message_thread_id: new FormControl('',[Validators.required]), 
      description: new FormControl('', [Validators.required]),
      
      
    });
  }
  back(){
    console.log("back")
    this.onBack.emit();
  }
  getdata(){
    let editId = this.messageId;
    
    this.Helper.makeRequest("admin/view-message/"+editId,{},"get",{toast:false}).subscribe(d=>{
      
      this.form.controls['message_thread_id'].setValue(d.data[0].message_thread_id);
      this.data= d.data;
    })
  }
  init(){
    console.log('previous item = ',this.messageId);
    if(this.messageId!=""){
      this.getdata()
     
    }
  }

  loading=false;
  submit(form:any){
 
      
    if(!this.form.valid ){
      return 1;
    }
    this.loading=true;
    
    
    this.Helper.makeRequest("admin/message-reply",this.form.value,"post").
    subscribe((data)=>{ 
      this.loading=false;
      
      form.resetForm();
       this.getdata();

    },(err)=>{
      this.loading=false;
      console.log(err.error);
      // this.form.value.dob=olddob
      this.Helper.showServerErrors(err.error.errors,this.form);
      this.Helper.toast(err.error.message,"error")
      this.loading=false;
      this.Helper.showLoader(false); 
       
    });
  }
}
